import HomeContainer from "./HomeContainer";

export default HomeContainer; //export default는 이름 맘대로 정해도 되는 듯
